/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import ForgotPasswordForm from '../components/forms/ForgotPasswordForm';
import OutlinedText from '../elements/OutlinedText';
import { users } from '../helpers/api';
import { Loader, Modal } from '~/components';
import { ResetPassword } from '~/compositions/ResetPassword';
import { PageContainer, Container } from './common';
import { ToastCtx } from '~/providers/ToastProvider';
import messages from '../helpers/api/messages';
import axiosInstance from '~/config/axios';
import {
  recaptchaRequest,
  setSiteKey,
  setSuccessKey,
} from '~/store/modules/recaptcha/actions';
import { VRPAT } from '~/config/constants';

const SendConfirmation = styled.p`
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
`;

export default function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [email, setEmail] = useState('');
  const { siteKey, successKey } = useSelector(state => state.recaptcha);
  const toast = useContext(ToastCtx);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const issuer = useSelector(state => state?.issuer);
  const isVR = issuer.name === VRPAT;

  /**
   * Limpando a chave de sucesso na alteração de rota para evitar conflito com outras telas que usam do mesmo local na store
   * O usuário poderia entrar na tela, clicar no recaptcha, e depois ir pra outra tela com recapctha e já estar validado, pois a store é global
   * Vêr a possibilidade de converter para um custom hook no futuro
   * */
  useEffect(() => {
    dispatch(setSuccessKey(''));
  }, [location]);

  async function handleEmailConfirmation(email) {
    try {
      const response = await users.resendEmailAuthentication(email);
      toast.dispatch(
        messages(
          response,
          'confirm_email',
          <>
            Um link de confirmação foi enviado para o e-mail: {email}. Caso não
            tenha recebido o e-mail de confirmação, verifique a sua caixa de
            spam ou lixeira.
          </>,
        ),
      );
    } catch (e) {
      toast.dispatch(messages(e, 'forgot_password'));
    }
  }

  function msgEmailConfirmation(email) {
    return (
      <>
        Para solicitar a alteração de senha, é necessário que o seu cadastro já
        tenha sido confirmado. Caso não tenha encontrado o link de ativação no
        seu e-mail, verifique sua caixa de Spam ou Lixeira. ou clique em&nbsp;
        <SendConfirmation onClick={() => handleEmailConfirmation(email)}>
          Enviar Novamente
        </SendConfirmation>
      </>
    );
  }

  async function getReCaptchaKey() {
    try {
      dispatch(recaptchaRequest());
      setIsLoading(true);
    } catch (e) {
      toast.dispatch(messages(e, 'recaptcha'));
    } finally {
      setIsLoading(false);
    }
  }

  function setAxiosHeader(key) {
    axiosInstance.defaults.headers.common = {
      'response-captcha': key,
    };
  }

  useEffect(() => {
    if (!siteKey) {
      getReCaptchaKey();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleCloseModal() {
    setModalIsOpen(false);

    if (currentStep === 'send_email_success') {
      history.push('/login');
    }
  }

  function handleSetStep(stepName) {
    setModalIsOpen(false);
    setTimeout(() => {
      setCurrentStep(stepName);
      setModalIsOpen(true);
    }, 500);
  }

  async function handleConfirmSubmit(payload) {
    setEmail(payload.email);
    setCurrentStep('confirm_send_email');
    setModalIsOpen(true);
  }

  async function handleSubmit(email) {
    setAxiosHeader(successKey);
    setIsLoading(true);

    try {
      await users.sendEmailChangePassword(email);
      // eslint-disable-next-line no-empty
    } catch (e) {
    } finally {
      handleSetStep('send_email_success');
      setAxiosHeader('');
      dispatch(setSiteKey(''));
      dispatch(setSuccessKey(''));
      setIsLoading(false);
    }
  }

  return (
    <PageContainer>
      <Container>
        <ForgotPasswordForm onSubmit={handleConfirmSubmit} />
      </Container>
      {isVR && <OutlinedText onlyMobile>issoévr</OutlinedText>}

      <Modal
        handleClose={() => handleCloseModal()}
        open={modalIsOpen}
        fullWidth
      >
        <Loader isLoading={isLoading}>
          <ResetPassword
            issuer={issuer?.company}
            email={email}
            currentStep={currentStep}
            handleClose={() => handleCloseModal()}
            handleSubmit={() => handleSubmit(email)}
          />
        </Loader>
      </Modal>
    </PageContainer>
  );
}
